/* eslint-disable */
import { Autocomplete, MenuItem, Select, TextField } from "@mui/material";

const CustomFormAutocompleteSelect = ({name, register, labelName, requiredMessage, list, onChange, ...restProps}) => {
    return (
        <Autocomplete
            {...restProps}
            id="controllable-states-demo"
            options={list}
            sx={{
                width: "100%",
                backgroundColor: "inherit",
                borderRadius:"4px",
                height:"36px",
                "& .MuiFormControl-root label":{color:"transparent"},
                "& .MuiAutocomplete-inputRoot":{marginTop:"5px",marginLeft:"5px"},
                "& .MuiAutocomplete-endAdornment":{right:"5px"},
                "& .MuiAutocomplete-endAdornment .MuiSvgIcon-root":{color:"#000"},
                "& .MuiFormLabel-root.Mui-focused":{color:"transparent"},
                "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"},
                "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            {...register(name, {
                required : requiredMessage
            })}
            onChange={onChange}
            renderInput={(params) => <TextField {...params} label={labelName} variant="standard" />}
        />
    );
};

export default CustomFormAutocompleteSelect;